
import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { DataModelDesigner } from './DataModelDesigner';

interface DataModelEditorModalProps {
    open: boolean;
    onClose: () => void;
    modelId: string | null;
    onSaveSuccess?: (model: any) => void;
}

export default function DataModelEditorModal({ open, onClose, modelId, onSaveSuccess }: DataModelEditorModalProps) {
    if (!open) return null;

    return (
        <Dialog open={open} onOpenChange={(val) => !val && onClose()}>
            <DialogContent
                className="max-w-[95vw] w-[95vw] h-[90vh] p-0 overflow-hidden flex flex-col bg-white"
                onKeyDown={(e) => e.stopPropagation()}
            >
                <DataModelDesigner
                    modelId={modelId}
                    onBack={onClose}
                    onSaveSuccess={onSaveSuccess}
                    fromFlow={true}
                />
            </DialogContent>
        </Dialog>
    );
}
